<template>
	<div class="empty">
		<div
			v-if="status"
			v-text="status"
			class="empty-header"
		/>
		<p
			v-if="title"
			v-text="title"
			class="empty-title"
		/>
		<p
			v-if="description"
			v-text="description"
			class="empty-subtitle text-muted"
		/>
		<div class="empty-action">
			<b-link
				exact
				:to="{ path: '/' }"
				class="btn btn-primary"
			>Go Back</b-link>
		</div>
	</div>
</template>

<script>
import { title } from '@/mixins'

const headers =
{
	503: 'Service Unavailable',
	500: 'Server Error',
	404: 'Page Not Found',
	403: 'Unauthorized',
	401: 'Unauthorized',
}

const descriptions =
{
	503: 'Sorry, we are doing some maintenance. Please check back soon.',
	500: 'Whoops, something went wrong behind the scenes.',
	404: 'Sorry, the page you are looking for could not be found.',
	403: 'Sorry, you are not authorized to access this page.',
	401: 'Sorry, you are not authorized to access this page.',
}

export default
{
	mixins:
	[
		title,
	],

	props:
	{
		status:
		{
			type:    [ Number, String ],
			default: 500,
		},
	},

	computed:
	{
		title()
		{
			return headers[this.status] ?? 'Error'
		},

		description()
		{
			return descriptions[this.status]
		},
	},
}
</script>